/**
 * The wizard's steps.
 *
 * The indexes are named because three separate things key off them - the step
 * bar, which panel renders, and which step a validation error sends you back
 * to - and a bare `step === 1` in any of them is unreadable the moment a step
 * is inserted.
 */
export const ANNOUNCEMENT_STEPS = ['Content', 'Audience', 'Schedule', 'Review'];

export const AnnouncementStep = {
  content: 0,
  audience: 1,
  schedule: 2,
  review: 3,
} as const;

export const LAST_ANNOUNCEMENT_STEP = ANNOUNCEMENT_STEPS.length - 1;
